import BaseChange from "./BaseChange"

export default class LoadedMap extends BaseChange {
  constructor() {
    super()
    this.setMessage({ message: "Map loaded", hide: true })
    this.type = "loadedMap"
  }
}
